import React, { useEffect, useState } from "react";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import Header from "./Header";
import NetworkCanvas from "./NetworkCanvas";
// Parsed-graph renderer — used by the commented-out JSON approach below. Re-enable
// this import together with that block to switch back from the iframe.
// import NetworkGraphView from "./NetworkGraphView";
import { properties } from "../properties";
import { ftAccessToken } from "../constants/Constants";

export default function NetworkGraph() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");

    const [smallScreen, setSmallScreen] = useState(window.innerWidth < 991);
    const [loading, setLoading] = useState(!smallScreen);

    // --- Parsed-graph state (disabled; restore with the data-fetch block below) ---
    // const [data, setData] = useState(null);
    // const [error, setError] = useState(null);

    useEffect(() => {
        const onResize = () => {
            const small = window.innerWidth < 991;
            setSmallScreen(small);
            if (small) setLoading(false);
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);

    // -------------------------------------------------------------------------
    // PARSED-GRAPH APPROACH — COMMENTED OUT (kept intentionally, do not delete).
    // We now render the raw graph HTML directly in an <iframe> (served by the
    // backend at GET /graph/{id}). The block below instead fetched the
    // server-parsed nodes/edges JSON from /graph/{id}/data and drew it with
    // <NetworkGraphView>. Uncomment this (and the import + state above, and the
    // JSX block below) to switch back.
    //
    // useEffect(() => {
    //     if (smallScreen || !id) return;
    //     let cancelled = false;
    //     const token = localStorage.getItem(ftAccessToken)?.replaceAll('"', "");
    //     fetch(`${properties.host}/graph/${id}/data`, {
    //         headers: { Authorization: `Bearer ${token}` },
    //     })
    //         .then((res) => {
    //             if (!res.ok) throw new Error("Unable to load network data.");
    //             return res.json();
    //         })
    //         .then((json) => { if (!cancelled) setData(json); })
    //         .catch((e) => { if (!cancelled) setError(e.message || "Network error"); });
    //     return () => { cancelled = true; };
    // }, [id, smallScreen]);
    //
    // const loading = !smallScreen && !data && !error;
    // -------------------------------------------------------------------------

    // The graph HTML is passed through the backend (GET /graph/{id}) and shown in
    // the iframe below. Iframes can't send an Authorization header, so the JWT is
    // passed as the ?accessToken query param, which the endpoint validates.
    const token = localStorage.getItem(ftAccessToken)?.replaceAll('"', "");

    return (
        <div className="home-layout">
            <Sidebar activePage="Submissions" />

            <main className="home-main">
                <Header />

                <div className="home-content">
                    <button className="chpw-back" onClick={() => navigate(`/submission?id=${id}`)}>
                        <ArrowLeft size={14} />
                        Back to Submission
                    </button>

                    <div className="score-history-card" style={{ marginBottom: 16 }}>
                        <p className="score-history-title">Network Discovery</p>
                        <p className="score-history-sub">Citation and similarity network for your manuscript</p>
                    </div>

                    {smallScreen ? (
                        <div className="submissions-card" style={{ padding: "32px 24px", textAlign: "center" }}>
                            <p className="settings-empty">Network Discovery is not available on small screens or mobile devices.</p>
                        </div>
                    ) : (
                        <div className="submissions-card" style={{ overflow: "hidden", padding: 0 }}>
                            {loading && (
                                <div style={{ height: "75vh", position: "relative", background: "#0f1a14", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <NetworkCanvas />
                                    <div style={{ position: "relative", zIndex: 1, textAlign: "center" }}>
                                        <p style={{ color: "rgba(255,255,255,0.75)", fontSize: 14, letterSpacing: "0.04em" }}>Building your network…</p>
                                    </div>
                                </div>
                            )}

                            <iframe
                                title="graph"
                                src={`${properties.host}/graph/${id}?accessToken=${token}`}
                                onLoad={() => setTimeout(() => setLoading(false), 3000)}
                                style={{
                                    display: loading ? "none" : "block",
                                    width: "100%",
                                    height: "75vh",
                                    border: "none",
                                }}
                            />

                            {/* PARSED-GRAPH RENDERING — COMMENTED OUT (see the data-fetch block above).
                            {error && !loading && (
                                <div style={{ height: "78vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 24, textAlign: "center" }}>
                                    <p className="settings-empty">{error}</p>
                                </div>
                            )}
                            {data && (
                                <NetworkGraphView
                                    nodes={data.nodes || []}
                                    edges={data.edges || []}
                                    paperTitle={data.paperTitle}
                                />
                            )}
                            */}
                        </div>
                    )}
                </div>
            </main>
        </div>
    );
}
